import { jsxs, jsx } from 'react/jsx-runtime';
import { Icon } from '../Icon/Icon.js';

const toastTitle = {
  info: 'Info',
  success: 'Success',
  warn: 'Warning',
  error: 'Error',
  secondary: 'Info',
  contrast: 'Info'
};
const toastIcon = {
  info: 'info_i',
  success: 'check_circle',
  warn: 'warning',
  error: 'error',
  secondary: 'info_i',
  contrast: 'info_i'
};
function ToastContent(_ref) {
  let {
    message
  } = _ref;
  var _a;
  const severity = (_a = message.severity) !== null && _a !== void 0 ? _a : 'info';
  return jsxs("div", {
    className: "flex flex-row gap-3 align-items-center",
    children: [jsx(Icon, {
      fontSize: "normal",
      className: "p-toast-message-icon",
      name: toastIcon[severity]
    }), jsxs("div", {
      className: "flex flex-column gap-1 align-items-start",
      children: [jsx("strong", {
        className: "p-toast-message-title",
        children: toastTitle[severity]
      }), jsx("div", {
        children: message.detail
      })]
    })]
  });
}

export { ToastContent };
